module.exports = __webpack_public_path__ + "static/fonts/Roboto-LightItalic.76ce6e2.eot";


//////////////////
// WEBPACK FOOTER
// ./node_modules/roboto-fontface/fonts/roboto/Roboto-LightItalic.eot
// module id = boo3
// module chunks = 3